import { sanitize } from 'dompurify';
import $$api from 'models/api';
import React, { useState } from 'react';
import styled from 'styled-components';

import CommunityTab from 'components/StyledTemplates/CommunityTab';
import PopUpWrapper from 'components/StyledTemplates/PopUpWrapper';
import { Frame } from 'components/StyledTemplates/StyledTemplates';

import useModal from 'hooks/useModal';
import useResources from 'hooks/useResources';

const TemplateEmailModal = () => {
    const [template, setTemplate] = useState<string>('');

    useModal('TEMPLATE_EMAIL', {
        onOpen: async (d: number) => {
            $$api.misc.getRoleHTMLTemplateFx(d).then(setTemplate);
        },
    });

    const { t } = useResources();

    return (
        <PopUpWrapper name="TEMPLATE_EMAIL" whiteCross={true} className="template-email-modal-dialog" size="lg">
            <CommunityTab title={t(`communityPage.assigned_LearnMore_PopUpTitle`)}>
                <HTMLWrapper dangerouslySetInnerHTML={{ __html: sanitize(template) }} />
            </CommunityTab>
        </PopUpWrapper>
    );
};

const HTMLWrapper = styled(Frame)<{ extra?: string }>`
    display: block;
    width: 100%;
    max-width: 900px;
    padding: 25px;
    box-sizing: border-box;
    border-radius: 10px;
    background: ${(props: any) => props?.theme?.background?.primary ?? `#FFFFFF`};
`;

export default TemplateEmailModal;
